import React, { useState, useContext } from "react";
import { i18n } from "../../translate/i18n";
import { 
    Avatar, 
    CardHeader, 
    Grid,
    Dialog,
    DialogContent,
    IconButton,
    Tooltip,
    CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AuthContext } from "../../context/Auth/AuthContext";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import api from "../../services/api";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
    // Estilos para o modal da imagem
    imageModal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    imageModalContent: {
        outline: "none",
        maxWidth: "90vw",
        maxHeight: "90vh",
    },
    expandedImage: {
        width: "100%",
        height: "auto",
        maxWidth: "500px",
        borderRadius: theme.spacing(1),
    },
    clickableAvatar: {
        cursor: "pointer",
        "&:hover": {
            opacity: 0.8,
        },
    },
    voiceButton: {
        color: theme.palette.primary.main,
        "&:hover": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
    const classes = useStyles();
    const [amount, setAmount] = useState("");
    const { user } = useContext(AuthContext);
    const [imageModalOpen, setImageModalOpen] = useState(false); // Estado para o modal da imagem
    const [loadingVoice, setLoadingVoice] = useState(false); // Estado para loading del botón de voz

    // Função para abrir modal da imagem
    const handleImageClick = (e) => {
        e.stopPropagation(); // Prevenir que o clique no avatar execute outros handlers
        if (contact?.urlPicture) {
            setImageModalOpen(true);
        }
    };

    // Função para fechar modal da imagem
    const handleImageModalClose = () => {
        setImageModalOpen(false);
    };

    // Función para generar respuesta de voz
    const handleVoiceResponse = async (e) => {
        e.stopPropagation();
        
        if (!ticket?.id) {
            toast.error("No hay ticket seleccionado");
            return;
        }

        setLoadingVoice(true);
        
        try {
            console.log("[Voice Button] Generando respuesta de voz para ticket:", ticket.id);
            
            const { data } = await api.post(`/elevenlabs/voice-response/${ticket.id}`);
            
            console.log("[Voice Button] Audio generado:", data);
            
            // Reproducir el audio
            const audio = new Audio(`${process.env.REACT_APP_BACKEND_URL}${data.url}`);
            audio.play();
            
            toast.success("Audio generado y reproducido exitosamente");
        } catch (error) {
            console.error("[Voice Button] Error generando audio:", error);
            toast.error(error.response?.data?.error || "Error al generar audio");
        } finally {
            setLoadingVoice(false);
        }
    };

    const renderCardReader = () => {
        return (
            <CardHeader
                onClick={onClick}
                style={{ cursor: "pointer" }}
                titleTypographyProps={{ noWrap: true }}
                subheaderTypographyProps={{ noWrap: true }}
                avatar={
                    <Avatar 
                        src={contact?.urlPicture} 
                        alt="contact_image" 
                        className={classes.clickableAvatar}
                        onClick={handleImageClick}
                    />
                }
                title={`${(contact?.name && contact.name.length > 12) ? 
                    `${contact.name.substring(0, 12)}...` : 
                    contact?.name || '(sem contato)'} #${ticket?.id}`}
                subheader={[
                    ticket?.user && `${i18n.t("messagesList.header.assignedTo")} ${ticket?.user?.name}`,
                    contact?.contactWallets && contact.contactWallets.length > 0
                        ? `• ${i18n.t("wallets.wallet")}: ${contact.contactWallets[0].wallet?.name || 'N/A'}`
                        : null
                ].filter(Boolean).join(' ')}
            />
        );
    }

    const handleChange = (event) => {
        const value = event.target.value;
        setAmount(value);
    }

    return (
        <React.Fragment>
            <Grid container alignItems="center" spacing={10}>
                {/* Conteúdo do contato à esquerda */}
                <Grid item xs={6}>
                    {renderCardReader()}
                </Grid>
                
                {/* Botón de Voz a la derecha */}
                <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Tooltip title="Generar respuesta de voz">
                        <IconButton
                            className={classes.voiceButton}
                            onClick={handleVoiceResponse}
                            disabled={loadingVoice || !ticket?.id}
                        >
                            {loadingVoice ? (
                                <CircularProgress size={24} />
                            ) : (
                                <RecordVoiceOverIcon />
                            )}
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>

            {/* Modal da Imagem */}
            <Dialog
                open={imageModalOpen}
                onClose={handleImageModalClose}
                className={classes.imageModal}
                maxWidth="md"
                fullWidth
            >
                <DialogContent className={classes.imageModalContent}>
                    <img 
                        src={contact?.urlPicture} 
                        alt={contact?.name || "Foto do contato"}
                        className={classes.expandedImage}
                    />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default TicketInfo;